/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const CommentSquareIcon: React.FC = (): JSX.Element => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.7 0H1.3C0.585 0 0 0.585 0 1.3V13L2.6 10.4H11.7C12.415 10.4 13 9.815 13 9.1V1.3C13 0.585 12.415 0 11.7 0Z"
      fill="#747474"
    />
  </svg>
);
